<div class="white-box">
  <h2>{{ 'reinvest.withdrawal3a.title' | translate }}</h2>

  <p class="intro-3a">
    {{ 'reinvest.withdrawal3a.intro' | translate }}
  </p>

  <div *ngIf="success" class="response-message">
    {{ 'reinvest.withdrawal_type_success' | translate }}
  </div>

  <div *ngIf="!success">
    <h4>{{ 'reinvest.withdrawal3a.reason.title' | translate }}</h4>
    <br />

    <form [formGroup]="withdrawForm" #withdrawFormEl="ngForm" (ngSubmit)="submitForm()">
      <h4 [ngClass]="{ invalid: withdrawFormEl.submitted && withdrawForm.invalid }" *ngIf="currentAccount.kind !== '3a'">
        {{ 'reinvest.withdrawal_type_title' | translate }}
      </h4>

      <ng-container *ngIf="currentAccount.kind !== '3a'; else show3AWithdrawOption">
        <div>
          <input class="form-radio" id="withdrawal_type_full" type="radio" value="full" formControlName="withdrawalType" required />
          <label for="withdrawal_type_full">{{ 'reinvest.withdrawal_type_full' | translate }}</label>
        </div>
        <div>
          <input class="form-radio" id="withdrawal_type_part" type="radio" value="partial" formControlName="withdrawalType" required />
          <label for="withdrawal_type_part">{{ 'reinvest.withdrawal_type_part' | translate }}</label>
        </div>
        <!-- <div>
          <input
            class="form-radio"
            id="withdrawal_type_liquidation"
            type="radio"
            value="liquidation"
            formControlName="withdrawalType"
            required
          />
          <label for="withdrawal_type_liquidation">{{ 'reinvest.withdrawal_type_liquidation' | translate }}</label>
          <app-ui-tooltip
            [content]="'reinvest.withdrawal_type_liquidation_tooltip' | translate"
            color="yellow"
            size="small"
          ></app-ui-tooltip>
        </div> -->
        <div>
          <input class="form-radio" id="withdrawal_type_other" type="radio" value="other" formControlName="withdrawalType" required />
          <label for="withdrawal_type_other">{{ 'reinvest.withdrawal_type_other' | translate }}</label>
        </div>
      </ng-container>
      <ng-template #show3AWithdrawOption>
        <div>
          <input
            class="form-radio"
            id="withdrawal_type_3a_retirement"
            type="radio"
            value="Retirement"
            formControlName="withdrawalType"
            required
          />
          <label for="withdrawal_type_3a_retirement">{{ 'reinvest.withdrawal3a.reason.retirment' | translate }}</label>
        </div>
        <div>
          <input
            class="form-radio"
            id="withdrawal_type_3a_home_ownership"
            type="radio"
            value="Financing home ownership"
            formControlName="withdrawalType"
            required
          />
          <label for="withdrawal_type_3a_home_ownership">{{ 'reinvest.withdrawal3a.reason.homeownership' | translate }}</label>
        </div>
        <div>
          <input
            class="form-radio"
            id="withdrawal_type_3a_self_employment"
            type="radio"
            value="Self-employment"
            formControlName="withdrawalType"
            required
          />
          <label for="withdrawal_type_3a_self_employment">{{ 'reinvest.withdrawal3a.reason.selfemployment' | translate }}</label>
        </div>
        <div>
          <input
            class="form-radio"
            id="withdrawal_type_3a_emigration"
            type="radio"
            value="Emigration abroad"
            formControlName="withdrawalType"
            required
          />
          <label for="withdrawal_type_3a_emigration">{{ 'reinvest.withdrawal3a.reason.emigrationabroad' | translate }}</label>
        </div>
        <div>
          <input
            class="form-radio"
            id="withdrawal_type_3a_buyin"
            type="radio"
            value="Buying into a pension fund"
            formControlName="withdrawalType"
            required
          />
          <label for="withdrawal_type_3a_buyin">{{ 'reinvest.withdrawal3a.reason.buyin' | translate }}</label>
        </div>
        <div>
          <input
            class="form-radio"
            id="withdrawal_type_3a_invalidity"
            type="radio"
            value="Invalidity"
            formControlName="withdrawalType"
            required
          />
          <label for="withdrawal_type_3a_invalidity">{{ 'reinvest.withdrawal3a.reason.invalidity' | translate }}</label>
        </div>
      </ng-template>
      <p *ngIf="withdrawFormEl.submitted && withdrawForm.invalid" class="required-field invalid">
        {{ 'reinvest.wthdrawal_field_required' | translate }}
      </p>
      <br />
      <h4>{{ 'reinvest.wthdrawal_message_title' | translate }}</h4>
      <textarea
        placeholder="{{
          (currentAccount.kind === '3a' ? 'reinvest.basic_message_placeholder' : 'reinvest.withdrawal_message_placeholder') | translate
        }}"
        name="message"
        formControlName="message"
      ></textarea>
      <button type="submit" type="submit" class="ui-button full-width" [class.loading]="loading">
        <span class="icon-i-windmill"></span>
        {{ 'reinvest.wthdrawal_submit_button' | translate }}
      </button>
    </form>
  </div>
</div>
